module.exports = __webpack_public_path__ + "static/media/LP1.2578d977.svg";